import { render, staticRenderFns } from "./showVideoList.vue?vue&type=template&id=3119584c&scoped=true&"
import script from "./showVideoList.vue?vue&type=script&lang=js&"
export * from "./showVideoList.vue?vue&type=script&lang=js&"
import style0 from "./showVideoList.vue?vue&type=style&index=0&id=3119584c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119584c",
  null
  
)

export default component.exports